import { useState } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { AuditLogList } from './AuditLogList'
import { AuditLogStatistics } from './AuditLogStatistics'
import { AuditLogArchive } from './AuditLogArchive'
import { useMe } from '@/hooks/useMe'
import { useMyPermissions } from '@/hooks/useMyPermissions'
import { AllowedAction } from '@/data/allowedActions'

export default function AuditLogsPage() {
  const [activeTab, setActiveTab] = useState('logs')
  const { user, isLoading } = useMe()
  const { hasPermission, isLoading: isPermLoading } = useMyPermissions()

  if (isLoading || isPermLoading) return null

  const isSysAdmin = user?.role_type === 'sys_admin'
  const hasProviderAuditRead = hasPermission('provider_audit_log', AllowedAction.R)

  if (!isSysAdmin && !hasProviderAuditRead) return null

  return (
    <div>
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">操作日誌</h1>
          <p className="text-muted-foreground mt-2">查看系統操作記錄與統計</p>
        </div>
      </div>

      <div className="h-4" />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="logs">操作記錄</TabsTrigger>
          <TabsTrigger value="statistics">統計資訊</TabsTrigger>
          {isSysAdmin && <TabsTrigger value="archive">歸檔管理</TabsTrigger>}
        </TabsList>

        <TabsContent value="logs">
          <AuditLogList />
        </TabsContent>

        <TabsContent value="statistics">
          <AuditLogStatistics />
        </TabsContent>

        {isSysAdmin && (
          <TabsContent value="archive">
            <AuditLogArchive />
          </TabsContent>
        )}
      </Tabs>
    </div>
  )
}
